// extracted by mini-css-extract-plugin
export default {"map":"locations_map__anIXi","regionsContainer":"locations_regionsContainer__J+idX"};